import React, { useState, useEffect, Fragment } from "react";

import "./App.css";
import { Route, Routes } from "react-router-dom";
import { AppLayout } from "./AppLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import { Box, Grid, Paper, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import PortfolioProjectMobile from "./pages/PortfolioProjectMobile";
import PortfolioProject from "./pages/PortfolioProject";
import {
  PORTFOLIO_PROJECTS,
  getDesktopColumns,
  getMobileColumn,
} from "./config/portfolioProjects";

const App = () => {
  const theme = useTheme();

  const lessMD = useMediaQuery(theme.breakpoints.down("md"));
  const lessSM = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(true);
  // const [disapear, setDisapear] = useState(false);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onPageLoad = () => {
      setShow(true);
    };
    // Check if the page has already loaded
    if (document.readyState === "complete") {
      window.setTimeout(() => {
        setShow(true);
      }, 100);
    } else {
      window.addEventListener("load", onPageLoad);
      setShow(false);
      setLoading(true);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);
  useEffect(() => {
    if (show) {
      window.setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  });
  if (loading) {
    window.scrollTo(0, 0);
  }
  return (
    <Fragment>
      <Grid
        container
        sx={{
          visibility: loading ? "visible" : "collapse",
          opacity: loading ? "100%" : "0",
          transition: "opacity .3s ease-in, visibility .35s",
          bgcolor: "black",
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "#050505",
          alignContent: "center",
          alignItem: "center",
          justifyItems: "center",
          justifyContent: "center",
          zIndex: 20000,
        }}
      >
        <img
          width={"200px"}
          alt="Logo white"
          style={{
            zIndex: 200001,
            position: "absolute",
            alignSelf: "center",
            justifySelf: "center",
            opacity: !!show ? "100%" : "0",

            transition: "opacity 1s ease-out, filter 1s linear",
          }}
          src="/assets/logo_white.png"
        />
        {/* <img
          width={"200px"}
          alt="Logo orange"
          style={{
            zIndex: 200000,
            position: "absolute",
            alignSelf: "center",
            justifySelf: "center",
          }}
          src="/assets/logo_orange.png"
        /> */}
      </Grid>
      <Box
        sx={{
          visibility: loading ? "visible" : "collapse",
          opacity: loading ? "100%" : "0",
          transition: "opacity .3s ease-in, visibility .35s",
          bgcolor: "black",
          position: "relative",
          width: "100%",
          height: loading ? 10000 : 0,
          backgroundColor: "#050505",
          alignContent: "center",
          alignItem: "center",
          justifyItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      />

      <Paper
        sx={{
          width: "100%",
          visibility: loading ? "hidden" : "visible",
          borderRadius: 0,
          overflow: "hidden",
          backgroundColor: "#050505",
        }}
      >
        <Routes>
          <Route path="/" element={<AppLayout lessSM={lessSM} />}>
            <Route
              index
              element={
                <Home lessMD={lessMD} lessSM={lessSM} loading={loading} />
              }
            />
            <Route
              path="/contact"
              element={
                <Contact lessMD={lessMD} lessSM={lessSM} loading={loading} />
              }
            />
            <Route
              path="/about"
              element={
                <About lessMD={lessMD} lessSM={lessSM} loading={loading} />
              }
            />
            <Route
              path="/portfolio"
              element={
                <Portfolio lessMD={lessMD} lessSM={lessSM} loading={loading} />
              }
            />
            {PORTFOLIO_PROJECTS.map((project) => {
              const { column1, column2 } = getDesktopColumns(
                project.imageCount
              );
              const column = getMobileColumn(project.imageCount);

              return (
                <Route
                  key={project.id}
                  path={`/portfolio/${project.slug}`}
                  element={
                    lessMD ? (
                      <PortfolioProjectMobile
                        folder={project.folder}
                        title={project.title}
                        description={project.description}
                        column={column}
                        lessSM={lessSM}
                      />
                    ) : (
                      <PortfolioProject
                        folder={project.folder}
                        title={project.title}
                        description={project.description}
                        column1={column1}
                        column2={column2}
                      />
                    )
                  }
                />
              );
            })}
          </Route>
        </Routes>
      </Paper>
    </Fragment>
  );
};

export default App;
